import React from "react";

const summaryCell =
  "border border-gray-400 dark:border-gray-500 border-b-2 border-b-gray-500 dark:border-b-gray-400 px-4 py-2.5";
const summaryCellTop =
  "border border-gray-400 dark:border-gray-500 border-t-4 border-t-gray-600 dark:border-t-gray-300 border-b-2 border-b-gray-500 dark:border-b-gray-400 px-4 py-2.5 bg-slate-100 dark:bg-slate-700/70";
const summaryAmountCell = `${summaryCell} text-right whitespace-nowrap`;
const summaryAmountCellTop = `${summaryCellTop} text-right whitespace-nowrap`;

function Amount({ formData }: any) {
  return (
    <tfoot className="bg-slate-100 dark:bg-slate-700/70">
      <tr>
        <td colSpan={5} className={`${summaryCellTop} text-xs font-medium text-slate-700 dark:text-slate-200`}>
          Newly Added Charges
        </td>
        <td className={`${summaryAmountCellTop} text-xs font-semibold text-slate-900 dark:text-slate-100`}>
          Rs {formData.total}
        </td>
        <td className={summaryCellTop}></td>
      </tr>
      <tr>
        <td
          colSpan={5}
          className={`${summaryCell} text-xs font-medium ${
            formData.lastDue > 0
              ? "text-red-600 dark:text-red-400"
              : "text-emerald-600 dark:text-emerald-400"
          }`}
        >
          {formData.lastDue > 0 ? "Previous Dues" : "Advance Received"}
        </td>
        <td
          className={`${summaryAmountCell} text-xs font-semibold ${
            formData.lastDue > 0
              ? "text-red-600 dark:text-red-400"
              : "text-emerald-600 dark:text-emerald-400"
          }`}
        >
          Rs {Math.abs(formData.lastDue)}
        </td>
        <td className={summaryCell}></td>
      </tr>
      <tr className="bg-indigo-100 dark:bg-indigo-900/40">
        <td
          colSpan={5}
          className="border border-gray-400 dark:border-gray-500 px-3 py-2.5 text-xs font-bold text-indigo-800 dark:text-indigo-200"
        >
          Total Payable
        </td>
        <td className="border border-gray-400 dark:border-gray-500 px-4 py-2.5 text-sm font-bold text-indigo-800 dark:text-indigo-200 text-right whitespace-nowrap">
          Rs {formData.payable}
        </td>
        <td className="border border-gray-400 dark:border-gray-500"></td>
      </tr>
    </tfoot>
  );
}

export default Amount;
